import { StyleSheet, Text, View } from 'react-native';

import { colors, fonts, fontSizes, radii, spacing } from '@/constants/theme';

/**
 * The app's toast pill (same look as the referrals tab's inline one —
 * extracted for the campaign home card; referrals can migrate later).
 * Render it as the LAST child of a screen's root view; the host owns the
 * message state + dismiss timer:
 *
 *   const [toast, setToast] = useState<string | null>(null);
 *   useEffect(() => { if (!toast) return; const t = setTimeout(() =>
 *     setToast(null), 1800); return () => clearTimeout(t); }, [toast]);
 *   ...
 *   <Toast message={toast} />
 */
export function Toast({ message }: { message: string | null }) {
  if (!message) return null;

  return (
    <View style={styles.toast} pointerEvents="none">
      <Text style={styles.toastText}>{message}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  toast: {
    position: 'absolute',
    left: spacing.lg,
    right: spacing.lg,
    bottom: spacing.xl,
    paddingHorizontal: spacing.base,
    paddingVertical: spacing.sm,
    backgroundColor: colors.deepGreen,
    borderRadius: radii.full,
    alignItems: 'center',
    justifyContent: 'center',
  },
  toastText: {
    fontFamily: fonts.bodyMedium,
    fontSize: fontSizes.sm,
    color: colors.frost,
  },
});
